<template>
    <div id="paypal-button-container"></div>
</template>
<script>
import {loadScript} from '@paypal/paypal-js';

export default {
    props: ["currency", "totalPrice", "client_id"],

    mounted() {
        async () => {
            try {
                const paypal = await loadScript({
                    clientId: this.client_id,
                    currency: this.currency,
                    dataPageType: 'checkout'
                });

                await paypal.Buttons({
                    createOrder: function(data, actions) {
                        return actions.order.create({
                            purchase_units: [{
                                amount: {
                                    value: `${this.totalPrice}`,
                                },
                            }],
                        });
                    },
                    onApprove: function(data, actions) {
                        return actions.order.capture().then(function(orderData) {
                            console.log(orderData);
                        });
                    },
                    style: {
                        layout: 'horizontal',
                        color: 'gold',
                        shape: 'rect',
                        label: 'paypal',
                    },
                }).render('#paypal-button-container');
            } catch (error) {
                console.log(error);
            }

        }
    }

}
</script>
